import { Answer } from '@/models/configurator/answer';
import { axios } from '@/plugins/axios';

export class AnswerService {
  private endpoint = 'v1/configurator/configurations/';

  async fetchAnswers(configurationId: number): Promise<Answer[]> {
    return axios
      .get<Answer[]>(`${this.endpoint}${configurationId}/answers/`)
      .then(({ data }) => data);
  }

  async fetchAnswer(configurationId: number, id: number): Promise<Answer> {
    return axios
      .get<Answer>(`${this.endpoint}${configurationId}/answers/${id}/`)
      .then(({ data }) => data);
  }

  async createAnswer(answer: Answer, snapshot?: number): Promise<Answer> {
    return axios
      .post<Answer>(
        `${this.endpoint}${answer.configuration}/answers/`,
        answer,
        { params: { pricing: snapshot } }
      )
      .then(({ data }) => data);
  }

  async updateAnswer(configurationId: number, answer: Answer): Promise<Answer> {
    return axios
      .patch<Answer>(
        `${this.endpoint}${configurationId}/answers/${answer.id}/`,
        answer
      )
      .then(({ data }) => data);
  }

  async deleteAnswer(configurationId: number, id: number): Promise<any> {
    return axios.delete(`${this.endpoint}${configurationId}/answers/${id}/`);
  }
}
